import { getCookies, setCookie, setPermanentCookie } from '../../store/cookies.js';

export const getOnboardingClosedCookie = closedCookieName => {
	return getCookies(closedCookieName);
};

export const setOnboardingClosedCookie = closedCookieName => {
	setCookie(closedCookieName, true);
};

export const getOnboardingDisabledCookie = disabledCookieName => {
	const cookie = getCookies(disabledCookieName);
	return cookie || false;
};

export const setOnboardingDisabledCookie = disabledCookieName => {
	const expireDate = new Date();
	expireDate.setFullYear(expireDate.getFullYear() + 1, expireDate.getMonth(), expireDate.getDay());
	setPermanentCookie(disabledCookieName, true, expireDate);
};
